export default {
    languages: {
        en: 'English',
        es: 'Español',
        zh: '中文',
        label: 'Language',
        hint: 'Choose the language for the website interface.',
    },
    common: {
        login: 'Login',
        register: 'Register',
        dashboard: 'Dashboard',
        logout: 'Logout',
        save: 'Save',
        cancel: 'Cancel',
        continue: 'Continue',
        loading: 'Loading…',
        renew: 'Renew',
        discord: 'Discord',
        getStarted: 'Get Started',
        learnMore: 'Learn more',
        back: 'Back',
        apply: 'Apply',
        copy: 'Copy',
        done: 'Done',
        view: 'View',
        close: 'Close',
        delete: 'Delete',
        create: 'Create',
        search: 'Search',
        recommended: 'Recommended',
        monthly: 'Monthly',
        lifetime: 'Lifetime',
        basic: 'Basic',
        advanced: 'Advanced',
        purchase: 'Purchase',
        checkout: 'Checkout',
        perMonth: '/mo',
        lifetimePrice: '{price} lifetime',
        confirm: 'Confirm',
        submitting: 'Submitting…',
        sending: 'Sending…',
        redeeming: 'Redeeming…',
        creating: 'Creating…',
        redirecting: 'Redirecting…',
        oneMonth: '1 month',
    },
    nav: {
        documentation: 'Docs',
        features: 'Features',
        pricing: 'Pricing',
        modules: 'Modules',
        updates: 'Updates',
        videos: 'Videos',
        media: 'Media',
    },
    sidebar: {
        dashboard: 'Dashboard',
        purchase: 'Purchase',
        download: 'Download',
        modules: 'Modules',
        playerList: 'Player List',
        configs: 'Configs',
        scripts: 'Scripts',
        referrals: 'Referrals',
        reseller: 'Reseller',
        media: 'Media',
        tickets: 'Tickets',
        guides: 'Guides',
        settings: 'Settings',
        manage: 'Manage',
        logout: 'Logout',
        license: 'License',
        renew: 'Renew',
        expires: 'Expires {when}',
        expired: 'Expired {when}',
    },
    auth: {
        loginTitle: 'Login',
        registerTitle: 'Register',
        username: 'Username',
        password: 'Password',
        email: 'Email',
        confirmPassword: 'Confirm Password',
        newPassword: 'New Password',
        forgotPassword: 'Forgot password?',
        noAccount: "Don't have an account?",
        hasAccount: 'Already have an account?',
        twoFactorRequired: 'Two-Factor Authentication required for {username}',
        twoFactorCode: '6-digit code',
        orRecovery: 'Or use a recovery code:',
        recoveryCode: 'Recovery code',
        backToLogin: 'Back to Login',
        verify: 'Verify',
        forgotTitle: 'Forgot password',
        forgotHint: 'Enter your email and we will send a reset link.',
        sendReset: 'Send reset link',
        resetSent: 'A password reset email was sent — check your inbox.',
        resetTitle: 'Reset password',
        resetHint: 'Please enter your new password.',
        resetSubmit: 'Reset password',
        resetSuccess: 'Success! Your password has been updated. You will be redirected to login.',
        cooldown: 'You can send another request in {minutes} minutes',
    },
    home: {
        brand: 'Dream Client',
        subtitle:
            'A powerful, customizable Minecraft client managed through your browser — secure, up to date, and built for performance.',
        whyTitle: 'Why Dream',
        whySubtitle: 'Built for control, coverage, and staying ahead of anti-cheats.',
        featureControlTitle: 'Remote & in-game control',
        featureControlText:
            'Basic runs entirely from the browser Web-GUI. Advanced adds external and internal menus so you can tune modules in-game or from anywhere.',
        featureVersionsTitle: 'Legacy + modern versions',
        featureVersionsText:
            'Support for 1.7–1.8, 1.12.2, and modern 1.20.6–26.2 Advanced builds — with shared modules plus 1.20+ exclusives.',
        featureSecureTitle: 'Updated & protected',
        featureSecureText:
            'Continuous updates against current anti-cheats, encrypted account data, and secure payments — so you stay competitive without the headaches.',
        pricingTitle: 'Pricing & Plans',
        pricingSubtitle: 'Same rates as checkout — pick Basic or Advanced and jump in.',
        basicName: 'Dream Basic',
        advancedName: 'Dream Advanced',
        basicTag: 'Web-GUI',
        advancedTag: 'External + internal menus',
        basicBullet1: 'Remote browser Web-GUI',
        basicBullet2: 'Minecraft 1.7–1.8',
        basicBullet3: '21 core modules',
        basicBullet4: 'Windows 10 / 11',
        advancedBullet1: 'External + internal menus',
        advancedBullet2: '1.7–1.8, 1.12.2 & 1.20.6–26.2',
        advancedBullet3: 'Shared + 1.20+ exclusive modules',
        advancedBullet4: 'Windows 10 / 11',
        viewModules: 'View modules',
        getAdvanced: 'Get Advanced',
        resellerTeaser: 'Looking to resell? Starter pack ~$200 at 35% off.',
        becomeReseller: 'Become a reseller',
        modulesTitle: 'Modules',
        modulesSubtitle: 'Browse what ships with Basic and Advanced.',
        videosTitle: 'Videos',
        videosSubtitle: 'See Dream Client in action.',
    },
    guestCheckout: {
        eyebrow: 'Direct checkout',
        title: 'Choose your access. Start in minutes.',
        subtitle: 'No account setup before payment. Pick a plan, pay securely, then create your Dream login from the confirmation screen or email.',
        instant: 'Instant delivery',
        mobileAdvancedPopular: 'Advanced · Most popular',
        perMonthShort: '/mo',
        accountAfter: 'Account after payment',
        secure: 'Secure PayPal checkout',
        chooseProduct: 'Choose your Dream',
        chooseProductHint: 'Compare coverage before you pay.',
        from: 'From {price}',
        chooseAccess: 'Choose access',
        monthly: 'Monthly',
        lifetime: 'Lifetime',
        bestValue: 'Best value',
        forOneMonth: 'for one month',
        oneTime: 'one-time payment',
        updatesIncluded: 'Ongoing product updates',
        checkout: 'Secure checkout',
        checkoutHint: 'Your plan is reserved to your email.',
        signedInTitle: 'Your account is ready to buy',
        signedInBody: 'Continue with the full dashboard checkout, including your current offers and payment options.',
        openDashboardCheckout: 'Open dashboard checkout',
        paymentComplete: 'Payment complete',
        successTitle: 'Your access is reserved',
        successBody: 'We sent setup instructions to {email}. You can create your account right now.',
        createAccountNow: 'Create my account',
        emailBackup: 'The same secure link is in your email.',
        emailLabel: 'Where should we deliver your access?',
        emailPlaceholder: "you{'@'}example.com",
        emailHint: 'We use this only for your receipt, access, and account setup.',
        processing: 'Confirming payment and preparing access…',
        termsLead: 'By paying, you agree to the',
        termsLink: 'Terms of Service',
        haveAccount: 'Already a customer?',
        signInInstead: 'Sign in and use your dashboard checkout',
        paypalSecure: 'Processed by PayPal',
        paypalPoweredBy: 'Powered by',
        noAccountFirst: 'No account required first',
        moreMethods: 'Need crypto or another method? Create or sign in to an account to use the full checkout.',
        genericError: 'Checkout could not be started. Please try again.',
        paypalUnavailable: 'PayPal is unavailable right now. Please use the account checkout.',
        validEmail: 'Enter a valid email before continuing.',
        cancelled: 'Payment was cancelled. Nothing was charged.',
    },
    publicUpdates: {
        eyebrow: 'Active development',
        title: 'Shipped recently.',
        live: 'Updated regularly',
        subtitle: 'Real releases, improvements, and fixes from the Dream changelog—visible before you buy.',
        version: 'Dream {version}',
        more: '+{count} more changes',
        empty: 'Fresh Dream updates will appear here.',
        cta: 'Every plan includes ongoing updates for its supported versions.',
        seePlans: 'Choose a plan',
    },
    claim: {
        eyebrow: 'Access ready',
        title: 'Create your Dream account',
        subtitle: 'Your purchase is complete. Choose the credentials you will use to access the dashboard and download.',
        purchasedFor: 'Purchase email',
        invalid: 'This setup link is incomplete or invalid. Open the link from your purchase email.',
        error: 'We could not finish your account setup. Please try again.',
        finishing: 'Creating your account…',
        submit: 'Create account & continue',
        note: 'Your purchase stays linked to this verified email.',
    },
    dashboard: {
        eyebrow: 'Dashboard',
        welcome: 'Welcome back, {username}',
        sub: 'Your account overview, live product stats, and the latest changelogs.',
        joinDiscord: 'Join Discord',
        createChangelog: 'Create Changelog',
        giveawaysTitle: 'Active Giveaways',
        giveawaysHint: 'Enter for a chance to win a license',
        enter: 'Enter',
        view: 'View',
        entered: 'Entered',
        youWon: 'You won — tap to view prize',
        expires: 'Expires {when}',
        drawn: 'Drawn {when}',
        entries: '{count} entries | {count} entry | {count} entries',
        activityTitle: 'Launches & Downloads',
        activityHint: 'Year-to-date monthly totals',
        changelogsTitle: 'Changelogs',
        userId: 'User ID',
        totalUsers: 'Total Users',
        totalLaunches: 'Total Launches',
        totalDownloads: 'Total Downloads',
        versionBasic: 'Version Basic',
        versionAdvanced: 'Version Advanced',
        communityEyebrow: 'Community',
        activityEyebrow: 'Activity',
        updatesEyebrow: 'Updates',
        toastLoadFailed: 'Failed to load information',
    },
    download: {
        eyebrow: 'Dream loader',
        title: 'Prepare your client',
        sub: 'Choose your Dream edition, set the loader identity, and generate your licensed Windows build.',
        licensed: 'License linked',
        editionEyebrow: 'Client edition',
        basicCopy: 'Browser Web-GUI control · Minecraft 1.7–1.8',
        advancedCopy: 'External + in-game control · Modern version support',
        licenseLabel: 'Access',
        licenseBound: 'Build bound to your account',
        identityEyebrow: 'Loader identity',
        identityTitle: 'Shape the executable',
        outputLabel: 'Generated loader',
        timestampCustom: 'Custom timestamp',
        timestampRandom: 'Random timestamp',
        devBuildHint: 'Staff-only channel',
        buildSummary: 'Ready to generate',
        building: 'Building loader…',

        buildActivity: 'Building your loader',
        buildProgressHint: 'Preparing a licensed build for your account and selected edition.',
        buildStageIdentity: 'Issuing authenticated distribution record',
        buildStageDos: 'Randomizing DOS metadata',
        buildStageHeaders: 'Applying COFF and PE headers',
        buildStageChecksum: 'Writing checksum and timestamp',
        buildStageImports: 'Shuffling import descriptors',
        buildStageSeal: 'Sealing licensed executable',
        buildDownload: 'Build & download',
        readinessEyebrow: 'System check',
        appType: 'Application type',
        fileName: 'Executable file name',
        fileNameHint: 'Defaults to AnyDesk.exe if left blank',
        fileNamePlaceholder: 'AnyDesk.exe',
        timestamp: 'Custom timestamp',
        timestampHint: 'Optional — a random timestamp is used when empty',
        download: 'Download',
        requirements: 'Requirements',
        windows: 'Windows 10 / 11 x64',
        licenseNeeded: 'Active Basic or Advanced license',
        os: 'OS',
        runtime: 'Runtime',
        osValue: 'Windows 10/11 x64',
        runtimeValue: 'VC++ Redistributable',
        devBuild: 'Download Dev Build',
        notesEyebrow: 'Notes',
        notesTitle: 'Before you run it',
        note1: 'Install the VC++ runtime if Windows asks for missing libraries.',
        note2: 'Custom file names help blend the loader with other tools.',
        note3: 'Leave timestamp empty to get a random build time.',
    },
    purchase: {
        eyebrow: 'Checkout',
        title: 'Purchase',
        sub: 'Pick a product and plan, then pay.',
        upgradeEyebrow: 'Upgrade',
        upgradeTitle: 'Upgrade to Advanced',
        upgradeSub: 'You already have Dream Basic. Unlock Advanced modules, modern versions, and in-game menus.',
        upgradeLead: 'Modern versions, in-game menus, and extra modules — Basic stays yours.',
        upgradePerk1: '1.20.6–26.2 support',
        upgradePerk2: 'External + in-game menus',
        upgradePerk3: 'Advanced combat & utility',
        upgradePriceLabel: 'Lifetime · {percent}% owner discount',
        payUpgrade: 'Pay upgrade',
        continueToPay: 'Continue to pay',
        seeWhatsNew: 'See what’s new',
        buyAsGift: 'Buy as gift',
        becomeReseller: 'Become a reseller',
        openReseller: 'Open Reseller Desk',
        giftLinks: 'Unredeemed gift links',
        yourGifts: 'Your gifts',
        copyLink: 'Copy link',
        allSetTitle: "You're all set",
        allSetSub:
            'You already own Basic and Advanced. Enable {gift} above to purchase for a friend, or use {reseller} to sell keys.',
        product: 'Product',
        plan: 'Plan',
        payNow: 'Pay now',
        upgradeTotal: 'Upgrade total',
        total: 'Total',
        payCrypto: 'Pay with Crypto',
        moreMethods: 'More payment methods',
        viewModules: 'View modules',
        partnerLabel: 'Featured partner',
        partnerTitle: 'Need a Minecraft account?',
        partnerBody: 'Affordable NFA & MFA accounts, including accounts with Hypixel ranks or Donut SMP balance.',
        partnerCta: 'Explore store',
        partnerAria: 'Visit fernan.club, featured Minecraft account store',
        acceptTerms: 'Accept Terms',
        viewTerms: 'View Terms',
        discountReferralKey: 'Discount, referral or license key',
        discountCode: 'Discount Code',
        referralCode: 'Referral Code',
        redeemKey: 'Redeem License Key',
        redeem: 'Redeem',
        giftMonthlyNote: 'Gift monthly licenses include 1 month of access.',
        upgradeLocked: 'Product locked to Advanced while upgrading from Basic.',
        upgradeFromBasic: 'Upgrade from Basic · {tag}',
        keepBasicNote: 'You’re upgrading from Basic. Your existing Basic access stays active.',
        lifetimeUpgradeDiscount: 'Lifetime Basic upgrade · {percent}% off',
        discountApplied: '{percent}% discount applied',
        webGuiTag: 'Web-GUI · Minecraft 1.7–1.8',
        advancedTag: 'External + internal menus · 1.7–26.2',
        fixedMonths: 'Buy fixed amount of months (no auto-renew)',
        giftComplete: 'Purchase complete',
        giftReady: 'Gift ready to share',
        giftProcessing: 'Your gift is being prepared. Check Your gifts in a moment if the link does not appear.',
        giftShareHint: 'Send the link on Discord. Your friend redeems after logging in. We also emailed these details to your account.',
        redeemLink: 'Redeem link',
        backupKey: 'Backup key',
        copyShareLink: 'Copy share link',
        fixedMonthsHint: 'Access ends after the selected months — you will need to re-purchase.',
        agreementEyebrow: 'Before checkout',
        termsTitle: 'Terms of Service',
        termsLead: 'In order to purchase Dream you must agree to our terms of service.',
        toastGiftCopied: 'Gift link copied',
        toastCopyLinkFailed: 'Could not copy link',
        toastKeyCopied: 'Key copied',
        toastCopyKeyFailed: 'Could not copy key',
        toastKeyRedeemed: 'Key redeemed successfully',
        toastSomethingWrong: 'Something went wrong',
        toastAssistantSelected: 'Selected Dream {product} · {plan}{gift}',
        toastGiftSuffix: ' · Gift',
        cryptoNoteTitle: 'Cryptocurrency Note',

        cryptoNoteBody: 'Please note if you pay with crypto your access may not be given immediately. Your transaction will be processed and you will receive it when that is complete. If you do not receive the product within 24 hours, make a ticket. Do NOT attempt to purchase again while a transaction is pending. This will likely result in the loss of funds.',
    },
    settings: {
        eyebrow: 'Account',
        title: 'Settings',
        sub: 'Manage your Dream account, security, and subscriptions.',
        languageEyebrow: 'Preferences',
        languageTitle: 'Language',
        languageHint: 'Choose the language for the website interface. This does not change legal Terms.',
        languageSaved: 'Language updated.',
        hardware: 'Hardware',
        profile: 'Profile',
        security: 'Security',
        staff: 'Staff',
        hwidTitle: 'HWID',
        hwidText: 'Run {dream} to copy your HWID when you see {auth}, then paste it here.',
        lastUpdated: 'Last updated',
        hwidSuccess: 'Successfully updated HWID. You may now access Dream.',
        usernameTitle: 'Username',
        usernameText: 'Change the username you use to log in.',
        usernameSuccess: 'Your username has been updated.',
        emailTitle: 'Email',
        emailText: 'Required for migration from the old system. You’ll get a verification email after updating.',
        emailSuccess: 'Email updated. Check your inbox for a verification link before using Dream again.',
        updateEmail: 'Update Email',
        passwordTitle: 'Change Password',
        oldPassword: 'Old Password',
        updateHwid: 'Update HWID',
        hwidPlaceholder: 'HWID',
        updateUsername: 'Update Username',
        changePassword: 'Change Password',
        discordTitle: 'Link Discord',
        discordText: 'Paste your Discord ID to get pinged on replies to tickets assigned to you.',
        discordPlaceholder: 'Discord ID',
        updateDiscord: 'Update Discord ID',
        twoFactorTitle: 'Two-Factor Authentication',
        twoFactorHint: 'Add an authenticator app code for an extra layer of login security.',
        twoFactorDisabled: '2FA is currently {status}.',
        twoFactorEnabled: '2FA is currently {status}.',
        twoFactorStatusDisabled: 'disabled',
        twoFactorStatusEnabled: 'enabled',
        brandDream: 'Dream',
        notAuthenticated: 'Not Authenticated',
        enable2fa: 'Enable 2FA',
        disable2fa: 'Disable 2FA',
        step1Qr: 'Step 1: Scan QR Code',
        step1QrHint: 'Scan with Google Authenticator, Authy, or similar:',
        step2Code: 'Step 2: Enter Verification Code',
        step2CodeHint: 'Enter the 6-digit code from your app:',
        verifyEnable: 'Verify & Enable',
        viewRecovery: 'View Recovery Codes',
        generateRecovery: 'Generate New Recovery Codes',
        recoveryTitle: 'Recovery Codes',
        recoveryHint: 'Store these somewhere safe. Each code can unlock your account if you lose your device.',
        hideRecovery: 'Hide Recovery Codes',
        disable2faTitle: 'Disable Two-Factor Authentication',
        disable2faHint: 'Enter your password and a 2FA or recovery code:',
        twoFactorOrRecovery: '2FA Code or Recovery Code',
        never: 'Never',
        dangerZone: 'Danger zone',
        subscriptionsTitle: 'Subscriptions & account',
        cancelSubscription: 'Cancel subscription',
        cancelBasicTitle: 'Cancel Basic PayPal subscription',
        cancelBasicText: 'You’ll lose Basic access after the current period expires.',
        cancelBasic: 'Cancel Basic',
        cancelAdvancedTitle: 'Cancel Advanced PayPal subscription',
        cancelAdvancedText: 'You’ll lose Advanced access after the current period expires.',
        cancelAdvanced: 'Cancel Advanced',
        deleteAccount: 'Delete account',
        deleteAccountText: 'Permanently removes your Dream account. This cannot be undone.',
        toastPasswordUpdated: 'Your password has been updated',
        toastPasswordFailed: 'Failed to update password',
        toastVerifyFailed: 'Failed to send verification',
        toastHwidUpdated: 'Updated HWID',
        toastHwidFailed: 'Failed to change HWID',
        toastUsernameUpdated: 'Updated Username',
        toastUsernameFailed: 'Failed to change Username',
        toastDiscordUpdated: 'Updated Discord ID',
        toastDiscordFailed: 'Failed to change Discord ID',
        toastAccountDeleted: 'Your account has been deleted',
        toastAccountDeleteFailed: 'Failed to delete account',
        toastSubCancelledBasic: 'Your Basic subscription has been cancelled',
        toastSubCancelledAdvanced: 'Your Advanced subscription has been cancelled',
        toastSubCancelFailed: 'Failed to cancel subscription',
        toast2faSecretFailed: 'Failed to generate 2FA secret',
        toast2faEnabled: '2FA has been enabled for your account',
        toast2faEnableFailed: 'Failed to enable 2FA',
        toast2faDisabled: '2FA has been disabled for your account',
        toast2faDisableFailed: 'Failed to disable 2FA',
        toastRecoveryViewFailed: 'Failed to view recovery codes',
        toastRecoveryGenerated: 'New recovery codes generated',
        toastRecoveryGenerateFailed: 'Failed to generate recovery codes',

        dialogPasswordTitle: 'Change Password',
        dialogPasswordText: 'Are you sure you want to change your password?',
        dialogDisable2faTitle: 'Disable 2FA',
        dialogDisable2faText: 'Are you sure you want to disable two-factor authentication?',
        dialogRecoveryTitle: 'Generate New Recovery Codes',
        dialogRecoveryText: 'This will generate new recovery codes and invalidate any existing ones. Are you sure?',
        dialogDeleteTitle: 'Enter Password',
        dialogDeleteText: 'Please enter your password to delete your account',
        dialogCancelSubTitle: 'Enter Password',
        dialogCancelSubText: 'Please enter your password to cancel this subscription',
    },
    scripts: {
        ui: {
            "details": "View details",
            "deleteScript": "Delete script",
            "deleting": "Deleting...",
            "delete": "Delete",
            "reading": "Reading script...",
            "startSource": "Start by choosing your .luau file",
            "prefill": "Prefill details from dream.module — you can edit everything below.",
            "sourceHint": "UTF-8 · up to 256 KiB. File contents are read locally, never executed.",
            "idHint": "Use author.module; each side needs 2+ lowercase letters, numbers, _ or -.",
            "nameHint": "3–64 characters.",
            "versionHint": "Semantic version such as 1.0.0 or 1.0.0-beta.1 (max 32).",
            "summaryHint": "10–240 characters.",
            "descriptionHint": "20–5,000 characters.",
            "visibility": "Visibility",
            "chooseVisibility": "Choose where this release goes",
            "privateReadyHint": "Private is ready for your loader immediately after automated checks.",
            "ownerOnly": "Owner only",
            "moderated": "Moderated",
            "private": "Private",
            "privateHint": "Only you can install it. No moderation queue.",
            "marketplaceHint": "Stays pending until a staff review approves it.",
            "chooseRuntime": "Choose one runtime",
            "runtimeHint": "Each release supports one client family.",
            "required": "Required",
            "chooseCapabilities": "Choose what the script uses",
            "capabilityHint": "Gameplay access is checked during review.",
            "privateNotice": "Automated checks run first, then this release becomes available only in your loader.",
            "localNotice": "This marketplace release stays in the local debug moderation queue.",
            "publicNotice": "Marketplace releases stay private to you while moderation is pending.",
            "uploadPrivate": "Upload private script",
            "submitting": "Submitting...",
            "submitMarketplace": "Submit to marketplace",
            "hideProfiles": "Hide cloud profiles",
            "cloudProfiles": "Cloud profiles",
            "noProfiles": "No cloud profiles saved for this script.",
            "noPersonalProfiles": "You have no cloud profiles for this script yet.",
            "enabled": "Enabled",
            "disabled": "Disabled",
            "checksPassed": "Automated checks passed",
            "validationReport": "Validation report",
            "submittedSource": "Submitted Luau source",
            "openReview": "Open to review",
            "sourceUnavailable": "Source is unavailable.",
            "author": "Author",
            "about": "About this script",
            "personalStorage": "Personal storage",
            "myProfiles": "My cloud profiles",
            "close": "Close",
            "unavailable": "Unavailable",
            "on": "On",
            "off": "Off",
            "unknown": "unknown",
            "privateReady": "Private - Ready",
            "marketplacePending": "Marketplace - Pending",
            "marketplacePublished": "Marketplace - Published",
            "marketplaceRejected": "Marketplace - Rejected",
            "validationPassed": "Automated validation passed.",
            "submittedMarketplace": "Release submitted for marketplace moderation.",
            "privateUploaded": "Private script validated and added to your loader.",
            "localSubmitted": "Marketplace release submitted to the local moderation queue.",
            "correctFields": "Please correct the highlighted upload fields.",
            "fileSelected": "File selected. Your existing details were kept; fill any missing fields below.",
            "readError": "Could not read this source. Save it as UTF-8 text and choose the file again.",
            "fileRange": "Choose a .luau file between 1 byte and 256 KiB.",
            "sourceRange": "The source file must be between 1 byte and 256 KiB.",
            "chooseSource": "Choose a .luau source file.",
            "sourceExtension": "Only .luau source files are accepted.",
            "invalidName": "The display name must be 3–64 characters.",
            "invalidSummary": "The summary must be 10–240 characters.",
            "invalidDescription": "The description must be 20–5,000 characters.",
            "invalidRuntime": "Select exactly one Minecraft runtime family.",
            "invalidVisibility": "Choose Private or Marketplace visibility.",
            "invalidCapabilities": "Select no more than 7 supported capabilities, without duplicates.",
            "invalidId": "Use author.module; each side needs at least 2 lowercase letters, numbers, underscores, or hyphens.",
            "invalidVersion": "Use a semantic version such as 1.0.0 or 1.0.0-beta.1 (maximum 32 characters).",
            "deleteProfile": "Delete cloud profile",
            "deleteDreamScript": "Delete Dream Script",
            "localListing": "local debug listing",
            "productionListing": "production listing",
            "by": "By {name}",
            "more": "+{count} more",
            "selected": "{count} selected",
            "saved": "{count} saved",
            "savedValues": "{count} saved values",
            "pending": "{count} pending",
            "revision": "v{version} - revision {revision}",
            "deleteNamed": "Delete {name}",
            "deleteProfileNamed": "Delete cloud profile {name}",
            "deleted": "{name} was deleted.",
            "confirmProfile": "Delete \"{name}\" from {script}? This cannot be undone.",
            "confirmScript": "Delete {id}? This permanently removes every version and saved profile in the {channel}. The other channel is not changed.",
            "imported": "Filled {fields}. Review version, runtime and capabilities before uploading.",
            "worldData": "Player & world data",
            "worldDataHint": "Read safe game snapshots",
            "drawing": "Drawing",
            "drawingHint": "Text, lines and shapes",
            "playerControls": "Player controls",
            "playerControlsHint": "Sprint and movement keys",
            "viewControl": "View control",
            "viewControlHint": "Yaw and pitch",
            "combatActions": "Combat actions",
            "combatActionsHint": "Attack or swing",
            "hotbarControl": "Hotbar control",
            "hotbarControlHint": "Choose slots 1–9",
            "worldInteraction": "World interaction",
            "worldInteractionHint": "Use blocks safely"
        },
        eyebrow: 'Advanced extensions',
        title: 'Dream Scripts',
        subtitle: 'Discover reviewed modules, publish source, manage cloud profiles in the loader, and learn the safe API.',
        memoryOnly: 'Memory-only client',
        memoryOnlyHint: 'Fetched per session; no scripts or profiles are saved to disk.',
        marketplace: 'Marketplace', mine: 'My scripts', docs: 'Docs', review: 'Review',
        search: 'Search scripts', allRuntimes: 'All runtimes', modern: 'Modern 1.20+', legacy: 'Legacy 1.7.10 / 1.8.9 / 1.12.2',
        mostLoaded: 'Most loaded', newest: 'Newest', refresh: 'Refresh', loads: 'loads',
        loaderOnly: 'Open the Dream loader to run this in memory.',
        emptyMarketplace: 'No reviewed scripts found', emptyMarketplaceHint: 'Try another filter or publish the first module.',
        publishEyebrow: 'Author tools', publishTitle: 'Submit a version', scriptId: 'Script ID', name: 'Name',
        version: 'Version', summary: 'Summary', description: 'Description', compatibility: 'Compatibility', permissions: 'Capabilities',
        chooseSource: 'Choose one .luau source file', reviewNotice: 'Every version is private until staff approves it.',
        uploading: 'Uploading…', submitReview: 'Submit for review', yourScriptsEyebrow: 'Release history', yourScripts: 'Your scripts',
        noUploads: 'You have not uploaded a script.', submitted: 'Version submitted for review.',
        reviewEyebrow: 'Moderation', reviewTitle: 'Pending versions', reviewNote: 'Review note', approve: 'Approve', reject: 'Reject',
        reviewEmpty: 'No versions are waiting for review.', reviewSaved: 'Review saved.',
        docsEyebrow: 'API version 1', docsTitle: 'Build a safe Dream module',
        docsIntro: 'Luau runs behind a small capability API shared by legacy and modern. Scripts never receive native handles or operating-system access.',
        genericError: 'The script request failed.',
    },

    configs: {
        eyebrow: 'Presets',
        title: 'Configs',
        sub: 'Browse presets by the modules they use, vote on the best setups, and apply one with a click.',
        showing: 'Showing',
        publish: 'Publish',
        filterAll: 'All',
        filterMine: 'Mine',
        filterPrivate: 'Private',
        filterPublic: 'Public',
        filterOfficial: 'Official',
        sortTop: 'Top',
        sortNew: 'New',
        versionModern: '1.20+',
        versionLegacy: '1.7–1.12',
        upvote: 'Upvote',
        downvote: 'Downvote',
        moduleCount: '{n} module | {n} modules',
        noModules: 'No customized modules',
        previewSettings: 'Preview settings',
        hideSettings: 'Hide settings',
        previewTitle: 'Config settings',
        previewSummary: '{modules} modules · {settings} modified settings',
        previewReadOnly: 'Read-only',
        settingCount: '{n} setting | {n} settings',
        customizedCount: '{n} customized',
        enabled: 'Enabled',
        boundTo: 'Bind: {key}',
        disabled: 'Disabled',
        notSet: 'Not set',
        noModuleSettings: 'No additional settings',
        noPreviewSettings: 'No modified module settings or binds to preview.',
        use: 'Use',
        delete: 'Delete config',
        emptyTitle: 'No configs found',
        emptySub: 'Try another filter, or publish your current setup for others to use.',
        publishCta: 'Publish a config',
        publishTitle: 'Publish Config',
        publishSub: 'Share your current Dream setup. Private stays yours; public is visible to everyone. Official is reserved for staff.',
        backToList: 'Back to configs',
        visibility: 'Visibility',
        visibilityHint: 'Choose who can see this config in the browser.',
        nameLabel: 'Config name',
        nameHint: '5–50 characters',
        namePlaceholder: 'Config Name',
        descriptionLabel: 'Description',
        descriptionHint: '10–300 characters — servers, play style, notes',
        descriptionPlaceholder: 'Config Description',
        publishSuccess: 'Successfully published config.',
        publishing: 'Publishing…',
        tipsEyebrow: 'Tips',
        tipsTitle: 'Before you publish',
        tip1: 'Use a clear name so others can find it quickly.',
        tip2: 'Mention the server or play style in the description.',
        tip3: 'Private configs are only visible to you.',
        tip4: 'Publishing snapshots your current module settings.',
        toastLoadFailed: 'Failed to load configs',
        toastOwnVote: 'You cannot vote on your own config',
        toastVoteFailed: 'Failed to vote',
        dialogUseTitle: 'Use Config',
        dialogUseText: 'Are you sure you want to use this config. It will override your existing config.',
        toastApplied: 'Config applied',
        toastUseFailed: 'Failed to use config',
        dialogDeleteTitle: 'Delete Config',
        dialogDeleteText: 'Are you sure you want to delete this config?',
        toastDeleted: 'Config deleted',
        toastDeleteFailed: 'Failed to delete config',
    },
    supportAssistant: {
        eyebrow: 'Dream support assistant', title: 'Dream assistant', hint: 'Ask about Dream Basic or Advanced before creating a ticket.', launchHint: 'Quick answers for configs, modules, HWID, media, and purchases', headerHint: 'Dream support · answers may be automated',
        clear: 'Clear conversation', collapse: 'Close assistant', greeting: 'Hi! I can help you find Dream settings and troubleshooting steps. Ask a question or choose a topic below.',
        examplesLabel: 'Example questions', examples: 'Try one of these:', exampleConfig: 'Load a config', exampleModules: 'Find module settings', exampleHwid: 'Fix an invalid HWID', exampleMedia: 'Media applications', examplePurchase: 'Purchase options',
        promptConfig: 'How do I load a config for Dream?', promptModules: 'Where can I find the module list and module settings?', promptHwid: 'I get an invalid HWID error. What should I check?', promptMedia: 'How do I submit a media application?', promptPurchase: 'What purchase options are available for Dream?',
        historyLabel: 'Conversation', you: 'You', assistant: 'Dream assistant', handoff: 'Still need help?', createTicket: 'Create a support ticket', openSource: 'Open {title}',
        loading: 'Thinking…', error: 'The support assistant is unavailable right now. Please try again or use Create Ticket.',
        productLabel: 'Dream product', productAll: 'All products', questionLabel: 'Your question', placeholder: 'Ask a question…',
        ask: 'Send', privacy: 'Enter sends · Shift + Enter adds a line. Do not include passwords, license keys, payment details, or other secrets. This chat is kept only in this page session.',
    },
    tickets: {
        eyebrow: 'Support',
        title: 'Tickets',
        sub: 'Create and track support tickets. Pick the right category so staff can help you faster.',
        showing: 'Showing',
        department: 'Department',
        create: 'Create Ticket',
        submit: 'Submit Ticket',
        titlePlaceholder: 'Ticket Title',
        detailHint: 'Enter your ticket details into the following text area. Please be as descriptive as possible to help us get your ticket resolved faster',
        bodyPlaceholder: 'Start typing your ticket here...',
        replyPlaceholder: 'Reply',
        send: 'Send',
        replied: 'Replied',
        createdLabel: 'Created',
        refresh: 'Refresh',
        refreshAria: 'Refresh tickets',
        filterAria: 'Ticket filter',
        showClosed: 'Show closed tickets',
        assignedBadge: 'Assigned',
        filterAny: 'Any',
        filterMine: 'Mine',
        filterDepartment: 'Department',
        filterAssigned: 'Assigned',
        filterUnassigned: 'Unassigned',
        emptyTitle: 'No tickets found',
        emptySub: 'Try another filter, or create a new support ticket.',
        deleteAria: 'Delete ticket',
        deleteReplyAria: 'Delete reply',
        allTickets: 'All tickets',
        assignedTo: 'Assigned to {username}',
        ticketNumber: 'Ticket #{id}',
        loadingTicket: 'Loading ticket…',
        assignStaff: 'Assign Staff',
        details: 'Details',
        labelTitle: 'Title',
        labelCategory: 'Category',
        labelCreator: 'Creator',
        labelCreated: 'Created',
        labelAssigned: 'Assigned',
        unassigned: 'Unassigned',
        stateOpen: 'Open',
        stateClosed: 'Closed',
        stateLocked: 'Locked',
        confirmCloseTitle: 'Confirm Close',
        confirmCloseText: 'Are you sure that you want to close this ticket? Tickets can not be reopened and you will need to create a new one.',
        confirmDeleteTitle: 'Confirm Delete',
        confirmDeleteText: 'Are you sure that you want to delete this ticket?',
        confirmDeleteReplyText: 'Are you sure you want to delete this reply?',
        loadFailed: 'Failed to load tickets',
        loadTicketFailed: 'Unable to load ticket',
        closeFailed: 'Failed to close ticket',
        deleteFailed: 'Failed to delete ticket',
        loadRepliesFailed: 'Failed to load replies',
        sendReplyFailed: 'Failed to send reply',
        deleteReplyFailed: 'Failed to delete reply',
        deptTechnical: 'Technical Support',
        deptSales: 'Sales',
        deptDetections: 'Detections',
        deptSuggestions: 'Suggestions',
        deptMedia: 'Media Application',
        deptOther: 'Other',
    },
    reseller: {
        eyebrow: 'Reseller desk',
        title: 'License Hub',
        sub: 'Build bulk invoices, track payments, and unlock keys — all in one place.',
        discount: 'Your discount',
        unusedKeys: 'Unused keys',
        redeemed: 'Redeemed',
        keysInCart: 'Keys in cart',
        storefront: 'Branded redeem page',
        copyLink: 'Copy link',
        tabPurchase: 'Purchase',
        tabInvoices: 'Invoices',
        tabStock: 'Stock',
        tabTools: 'Tools',
        bulkPurchase: 'Bulk Purchase',
        bulkPurchaseSub: 'Mix plans and packages in a single invoice.',
        licenseN: 'License {n}',
        remove: 'Remove',
        plan: 'Plan',
        package: 'Package',
        quantity: 'Quantity',
        addLicenseType: 'Add Another License Type',
        basicMonthly: 'Basic monthly',
        basicLifetime: 'Basic lifetime',
        advancedMonthly: 'Advanced monthly',
        advancedLifetime: 'Advanced lifetime',
        orderSummary: 'Order summary',
        readyToInvoice: 'Ready to invoice',
        total: 'Total',
        includesDiscount: 'Includes {percent}% reseller discount',
        listPriceHint: 'Unit rates above are list prices before your discount.',
        createInvoice: 'Create Invoice',
        invoicesTitle: 'Invoices',
        invoicesSub: 'Paid invoices unlock their license keys.',
        colId: 'ID',
        colDetails: 'Details',
        colQuantity: 'Quantity',
        colStatus: 'Status',
        colDate: 'Date',
        colActions: 'Actions',
        paid: 'Paid',
        unpaid: 'Unpaid',
        pageN: 'Page {n}',
        prev: 'Prev',
        next: 'Next',
        keyStock: 'Key stock',
        keyStockSub: 'Keys generated from your paid invoices.',
        exportUnused: 'Export unused',
        filterAll: 'All',
        filterUnused: 'Unused',
        filterUsed: 'Used',
        anyType: 'Any type',
        anyPlan: 'Any plan',
        colKey: 'Key',
        colType: 'Type',
        colPlan: 'Plan',
        used: 'Used',
        unused: 'Unused',
        stockTotal: '{n} total',
        salesAnalytics: 'Sales analytics',
        salesAnalyticsSub:
            'Estimated profit at list price (your {percent}% wholesale discount) · last 30 days',
        allTimeProfit: 'All-time profit',
        allTimeProfitDetail: "· {'$'}{spend} spent · {keys} keys",
        profit30d: 'Profit (30d)',
        profitHint: "From redeemed keys {'@'} list",
        openMargin: 'Open margin',
        openMarginHint: "Unused stock if sold {'@'} list",
        spent30d: 'Spent (30d)',
        sellThrough: 'Sell-through',
        sellThroughHint: '{n} bought · 30d',
        salesChartAria: 'Estimated profit and wholesale spend over the last 30 days',
        salesChartEmpty:
            'No activity yet — profit appears as customers redeem your keys (estimated at list price).',
        purchaseMix: 'Purchase mix (30d)',
        mixChartAria: 'Keys bought by product type',
        mixChartEmpty: 'No purchases yet',
        marginCalculator: 'Margin calculator',
        marginCalculatorSub: 'You get {percent}% off list. Enter your sell price to see profit.',
        product: 'Product',
        sellPrice: 'Your sell price ($)',
        matchList: 'Match list',
        breakEven: 'Break-even',
        list: 'List',
        yourCost: 'Your cost',
        profitPerKey: 'Profit / key',
        marginPercentLabel: '{n}% margin',
        redemptions: 'Redemptions',
        redemptionsSub: 'Daily key redemptions from your stock · last 30 days',
        redemptionsTotal: 'Total',
        bestDay: 'Best day',
        activeDays: 'Active days',
        redemptionsChartAria: 'Redemptions over the last 30 days',
        redemptionsChartEmpty: 'No redemptions yet — the chart fills in as customers use your keys.',
        invoiceN: 'Invoice #{id}',
        status: 'Status',
        details: 'Details',
        payInvoice: 'Pay Invoice',
        sandboxMode: 'SANDBOX MODE ENABLED',
        payWithCrypto: 'Pay with Crypto',
        keys: 'Keys',
        toastLoadStockFailed: 'Failed to load stock',
        toastCopiedUnused: 'Copied {count} unused keys',
        toastExportFailed: 'Export failed',
        toastCopied: 'Copied',
        toastCopyFailed: 'Copy failed',
        toastInvoiceCreated: 'Invoice created successfully',
        toastInvoiceCreateFailed: 'Failed to create invoice',
        deleteInvoiceTitle: 'Delete Invoice',
        deleteInvoiceConfirm: 'Are you sure you want to delete this invoice?',
        toastInvoiceDeleted: 'Invoice deleted',
        toastInvoiceDeleteFailed: 'Failed to delete invoice',
        toastLoadInvoiceFailed: 'Failed to load invoice details',
        toastPaymentCreateFailed: 'Payment creation failed',
        toastPaymentSuccess: 'Payment successful! Keys generated.',
        toastPaymentVerifyFailed: 'Payment verification failed',
        cryptoPaymentTitle: 'Crypto Payment',
        cryptoPaymentConfirm: 'Pay with Crypto?',
        toastCryptoInitiated: 'Crypto payment initiated...',
        toastPaymentUrlFailed: 'Failed to get payment URL',
        toastCryptoCreateFailed: 'Crypto payment creation failed',
        chartRedemptions: 'Redemptions',
        chartRedeemed: '{n} redeemed',
        chartProfit: 'Profit ($)',
        chartSpend: 'Spend ($)',
        chartKeysBought: 'Keys bought: {n}',
        chartKeys: 'Keys',
        chartKeysCount: '{n} keys',
    },
    guides: {
        eyebrow: 'Help',
        title: 'Guides',
        sub: 'Setup, bypass, and troubleshooting articles.',
        search: 'Search guides',
        showing: 'Showing',
        create: 'Create Guide',
        view: 'View guide',
        emptyTitle: 'No guides found',
        emptySub: 'Try another category, or create a new guide if you have access.',
        filterAll: 'All',
        filterBypass: 'Bypass',
        filterSetup: 'Setup',
        filterTroubleshoot: 'Troubleshoot',
        filterAria: 'Guide filter',
    },
    modules: {
        browserControl: 'Browser control',
        workspaceHint: 'Your modules, configured your way.',
        connected: 'Connected',
        waiting: 'Waiting for client',
        stopped: 'Stopped',
        globalSettings: 'Global settings',
        globalHint: 'Preferences that apply across all your modules.',
        settingsHint: 'Changes are saved automatically as you adjust your settings.',
        saving: 'Saving changes…',
        saved: 'All changes saved',
        saveFailed: 'Could not save changes. Please try again.',
        more: 'More',
        library: 'Module library',
        search: 'Find a module…',
        active: 'active',
        enabled: 'Enabled',
        disabled: 'Disabled',
        toggleModule: 'Enable {name}',
        noResults: 'No modules match your search.',
        chooseModule: 'Choose a module to configure',
        keybind: 'Keybind',
        keybindHint: 'Set a key to toggle this module in game.',
        boundHint: 'Use {key} in game to toggle, or clear the keybind for browser control.',
        bindingHint: 'Press a key to bind. Escape clears the keybind.',
        pressKey: 'Press a key…',
        notBound: 'Not bound',
        clear: 'Clear',
        retry: 'Try again',
        ready: 'Ready when you are',
        startWorkspaceHint: 'Start your session here, then connect the Dream client to manage your modules. Destruct ends the session.',
        categories: { all: 'All', combat: 'Combat', visual: 'Visual', utility: 'Utility' },
        themes: { cards: 'Cards', wide: 'Wide cards', workspace: 'Workspace' },
        expandSettings: 'Expand {name} settings',
        collapseSettings: 'Collapse {name} settings',
        inGame: 'In game',
        boundTo: 'Bound to {key}',
        title: 'Modules',
        running: 'Running',
        notConnected: 'Not Connected',
        start: 'Start',
        destruct: 'Destruct',
        switchTheme: 'Switch Theme',
        popOut: 'Pop Out',
        publishConfig: 'Publish Config',
        startHint:
            'To prevent detection Dream will not run unless you start it first here in the Web-GUI — hit the start button to begin. To stop yourself from getting detected, push the destruct button to stop the cheat.',
        toastStartFailed: 'Failed to change started status',
        toastLoadFailed: 'Failed to load modules',
    },
    gifts: {
        eyebrow: 'Gift license',
        title: 'Someone sent you Dream',
        goHome: 'Go home',
        alreadyRedeemed: 'This gift was already redeemed.',
        loginHint: 'Log in or create an account to redeem this gift.',
        redeem: 'Redeem gift',
        openDashboard: 'Open dashboard',
        notFound: 'Gift not found',
        toastSuccess: 'Gift redeemed — welcome to Dream',
        toastFailed: 'Could not redeem gift',
        productLine: 'Dream {product} · {plan}',
    },
    storefront: {
        eyebrow: 'Authorized reseller',
        sub: 'Redeem a Dream license key purchased from this reseller.',
        keyLabel: 'License key',
        loginHint: 'Log in or register to redeem. We’ll bring you back here.',
        redeem: 'Redeem key',
        notFound: 'Storefront not found',
        toastSuccess: 'Key redeemed',
        invalidKey: 'Invalid or already used key',
    },
    banned: {
        code: 'Banned',
        title: 'Your account has been banned from accessing Dream Client.',
        submitLabel: 'Submit a ban appeal',
        deniedHint: 'Your previous appeal was denied{note}. You can submit a new one.',
        deniedNote: ': {note}',
        countryLabel: 'Country',
        countryPlaceholder: 'Where are you located?',
        ispLabel: 'ISP / internet provider',
        ispPlaceholder: 'e.g. Comcast, Vodafone, Starlink…',
        whyBannedLabel: 'Why do you think your account got banned?',
        whyBannedPlaceholder: 'Describe what you believe led to the ban…',
        sharedLabel: 'Have you shared your account?',
        sharedYes: 'Yes',
        sharedNo: 'No',
        sharedRequired: 'Please select whether you have shared your account.',
        messagePlaceholder: 'Anything else you would like to add (optional)…',
        additionalLabel: 'Additional details (optional)',
        submit: 'Submit appeal',
        staffNote: 'Staff note:',
        replyPlaceholder: 'Reply to staff…',
        sendReply: 'Send reply',
        submitNew: 'Submit new appeal',
        statusOpen: 'Under review',
        statusAccepted: 'Accepted',
        statusDenied: 'Denied',
        loadReasonFailed: 'Unable to load ban reason',
        toastLoadFailed: 'Failed to load appeal',
        toastAccepted: 'Your appeal was accepted — welcome back!',
        toastSubmitted: 'Appeal submitted',
        toastSubmitFailed: 'Failed to submit appeal',
        toastReplyFailed: 'Failed to send reply',
    },
    assistant: {
        eyebrow: 'Quick help',
        title: 'Not sure which plan?',
        sub: 'A few quick questions — we’ll recommend the best fit.',
        skip: 'Skip',
        launch: 'Not sure which plan? Get a recommendation',
        qVersion: 'Which Minecraft version do you play?',
        qPlaystyle: 'What matters most?',
        qCommitment: 'How do you want to start?',
        qProduct: 'Which product fits you?',
        combat: 'PvP / combat',
        visuals: 'Visuals / ESP',
        utility: 'Utility / QoL',
        everything: 'A bit of everything',
        tryMonthly: 'Try monthly',
        buyLifetime: 'Buy lifetime',
        giftFriend: 'Gift for a friend',
        basicTitle: 'Dream Basic',
        basicSub: 'Web GUI · made for 1.7–1.8',
        advancedTitle: 'Dream Advanced',
        advancedSub: 'Also works on 1.7–1.8 · more menus',
        recommended: 'Recommended for you',
        giftBadge: 'Gift',
        usePlan: 'Use this plan',
        startOver: 'Start over',
        whyCombat: ' Strong fit if PvP / combat is your priority.',
        whyVisuals: ' Good match if you care most about ESP / visuals.',
        whyUtility: ' Solid if you want inventory, macros, and QoL tools.',
        whyEverything: ' Built for players who want a full toolkit.',
        whyBasic78: 'Dream Basic is made for Minecraft 1.7–1.8 (web GUI).',
        whyAdvanced78: 'Dream Advanced also supports 1.7–1.8, with external + internal menus.',
        whyLegacy12: '1.12 is supported by Dream Advanced (external + internal menus).',
        whyModern: '1.20+ needs Dream Advanced (external + internal menus).',
        whyGift: ' Gift lifetime — your friend redeems the link after logging in.',
        whyMonthly: ' Monthly lets you try before committing.',
        whyLifetime: ' Lifetime is the best value if you plan to stay.',
        productBasic: 'Dream Basic',
        productAdvanced: 'Dream Advanced',
    },
    becomeReseller: {
        badge: 'Reseller',
        title: 'Become a reseller',
        lead: "Pay ~{'$'}{amount} for a starter license pack at {percent}% off, then sell keys from the Reseller Desk.",
        namePlaceholder: 'Reseller name or website',
        confirm: 'I understand I receive license keys to resell and that this purchase is non-refundable.',
        continue: 'Continue to payment',
        totalDue: 'Total due:',
        toastCreateFailed: 'Failed to create activation invoice',
        toastPaymentFailed: 'Payment creation failed',
        toastWelcome: 'Welcome! Reseller pack unlocked.',
        toastVerifyFailed: 'Payment verification failed',
        toastPaypalFailed: 'Failed to load PayPal',
        toastPaymentUrlFailed: 'Failed to get payment URL',
        toastCryptoFailed: 'Crypto payment creation failed',
        itemLabel: '{pkg} {plan}',
    },
    trustedResellers: {
        eyebrow: 'Payment options',
        title: 'Our Trusted Resellers',
        lead: 'Buy through an authorized reseller with card, wallet, bank transfer, crypto, and more. After purchase you’ll get an email with the next steps.',
        altMethods: '+ Alternative payment methods',
        empty: 'No trusted resellers are available right now. Please try again later or use another payment method.',
        visit: 'Visit {name}',
        loadError: 'Could not load trusted resellers. Please try again.',
        methodsAria: 'Accepted payment methods',
        sitesAria: 'Reseller websites',
        methodCard: 'Debit | Credit | Pre-paid card',
        methodApple: 'Apple Pay',
        methodGoogle: 'Google Pay',
        methodBank: 'Bank Transfer (US, SEPA Direct)',
        methodCashApp: 'CashApp',
        methodCrypto: 'Cryptocurrency',
        methodIdeal: 'iDEAL',
    },
    cryptoCheckout: {
        title: 'Pay with Crypto',
        subtitle: 'Stay on Dream — pick a coin and send the exact amount.',
        pickCoin: 'Choose cryptocurrency',
        popular: 'Popular',
        allCoins: 'All coins',
        search: 'Search coins…',
        continue: 'Continue',
        selected: 'Selected',
        sandbox: 'Sandbox',
        sandboxCase: 'Test case',
        sendExactly: 'Send exactly',
        toAddress: 'To this address',
        copyAddress: 'Copy address',
        copied: 'Address copied',
        fiatTotal: 'Order total',
        status: 'Status',
        waiting: 'Waiting for payment',
        confirming: 'Confirming…',
        successTitle: 'Payment received',
        successBody: 'Your access is being unlocked. You can continue to the dashboard.',
        goDashboard: 'Go to dashboard',
        failedTitle: 'Payment failed',
        failedBody: 'This payment did not complete. You can try again with another coin.',
        retry: 'Try again',
        close: 'Close',
        creating: 'Creating payment…',
        expires: 'Expires',
        note: 'Send only the selected coin to this address. Access unlocks after the network confirms the payment.',
    },
    dialogs: {
        inputPlaceholder: 'Value',
    },
    message: {
        eyebrow: 'Announcement',
        title: 'Received Message',
    },
    migrate: {
        title: 'Welcome back!',
        body: 'Hey, returning customer — there is a new update for Dream Client and we now require you to provide an email for security & password resetting purposes. You will not be able to use Dream Client until you add one.',
        success: 'Sent a confirmation email — check your inbox.',
        submit: 'Send Confirmation',
        toastFailed: 'Failed to send verification',
    },
    verifyEmail: {
        verifying: 'Verifying email…',
        toastFailed: 'Failed to verify email',
    },
    notFound: {
        title: 'Page not found',
        text: 'The requested page could not be found.',
        cta: 'Return Home',
    },
    referrals: {
        eyebrow: 'Media program',
        title: 'Referrals',
        sub: 'Earn money for every user that signs up to Dream with your referral code.',
        openTicket: 'Open ticket',
        currentUses: 'Current uses',
        totalUses: 'Total uses',
        availableEarnings: 'Available earnings',
        withdrawAt: 'Withdraw at',
        empty: 'No referral account is linked to this user yet.',
        linkEyebrow: 'Your link',
        shareTitle: 'Share & earn',
        shareText: 'Send this link to your audience. Withdrawals open once you hit {amount} — then open a ticket under the {category} category.',
        withdrawReady: 'You have reached the minimum to withdraw. Open a ticket to receive your earnings.',
        copyLink: 'Copy Referral Link',
        howItWorks: 'How it works',
        payoutsTitle: 'Payouts',
        step1: 'Users who join with your code count toward your uses.',
        step2: 'Earnings unlock at {amount}.',
        step3: 'Request payout via a ticket in the {category} category.',
        loadError: 'Failed to load referral earnings',
    },
    media: {
        hero: {
            title: 'Show Dream in action.',
            titleAccent: 'Get licensed to create.',
            copy: 'Create Minecraft videos, clips, or streams featuring Dream. Accepted creators receive time-limited product licenses in exchange for an agreed content plan, plus direct support from our media team.',
            signIn: 'Sign in to apply',
            startApplication: 'Start your application',
            openWorkspace: 'Open your workspace',
            assurance: 'Licenses are linked to your Dream account and content plan',
            create: 'Create',
            publish: 'Publish',
            grow: 'Grow',
            caption: 'License · create · publish',
        },
        overview: {
            title: 'Pick the creator tier that fits your channel',
            copy: 'There is no weekly or monthly upload requirement. Publish when ready: each approved video adds 1 week for Trial Creators or 1 month for Established Creators. Media Partners keep their Media role active.',
            affiliateBadge: 'Media + affiliate',
            licenseWindow: 'License window',
            accessRenewal: 'Access renewal',
        },
        tiers: {
            trial: {
                name: 'Trial Creator',
                range: '50–500 audience',
                copy: 'Use the 2-day starter license to record your first Dream video. After our team approves it, we add 1 week to your license.',
                start: '2-day starter license',
                renewal: 'Per approved video: +1 week access',
            },
            established: {
                name: 'Established Creator',
                range: '500+ audience',
                copy: 'Use the 1-week starter license to create your Dream video. After our team approves it, we add 1 month to your license.',
                start: '1-week starter license',
                renewal: 'Per approved video: +1 month access',
            },
            partner: {
                name: 'Media Partner',
                range: 'High-fit channels',
                copy: 'Receive the Media role for ongoing creator access, with affiliate links and commission payouts included. Approved Dream videos are recorded in your partnership timeline.',
                start: 'Media role access',
                renewal: 'Approved videos recorded; Media role stays active',
            },
        },
        guest: {
            title: 'Ready to feature Dream?',
            copy: 'Apply with your Minecraft channel. If accepted, we will agree your license window and the Dream content you will publish.',
            createAccount: 'Create an account',
        },
        intake: {
            closedTitle: 'Media applications are currently closed',
            closedFallback: 'New Dream Media applications are temporarily unavailable. Existing creator workspaces remain accessible.',
        },
        apply: {
            title: 'Show us your Minecraft channel.',
            copy: 'These details help us review audience fit, set a license window, and agree realistic content deliverables.',
            steps: {
                channel: 'Channel',
                channelCopy: 'Where you publish Minecraft content',
                plan: 'Content plan',
                planCopy: 'How you would feature Dream',
                review: 'License review',
                reviewCopy: 'We match access to deliverables',
            },
            channelProfile: 'Channel profile',
            primaryPlatform: 'Primary platform',
            other: 'Other',
            channelName: 'Channel name',
            channelNamePlaceholder: 'Your creator name',
            channelUrl: 'Channel URL',
            followers: 'Followers / subscribers',
            typicalViews: 'Typical views per post',
            contentLanguage: 'Content language',
            languagePlaceholder: 'English, Spanish…',
            categories: 'Content categories',
            categoriesPlaceholder: 'Minecraft, PvP, tutorials…',
            fitTitle: 'Content & license fit',
            experience: 'Tell us about your content experience',
            experiencePlaceholder: 'How long have you been creating, and what performs best?',
            motivation: 'Why do you want to join Dream Media?',
            motivationPlaceholder: 'Why is Dream a good fit for your Minecraft audience?',
            feature: 'How would you feature Dream?',
            featurePlaceholder: 'Share video, Shorts, TikTok, or stream ideas and a realistic publishing schedule.',
            agreement: 'I confirm these details are accurate and understand that each license extension is granted after the Dream team approves a published video.',
            submitting: 'Submitting…',
            submit: 'Send application',
        },
        workspace: {
            titleDefault: 'Media Partner workspace',
            titles: {
                submitted: 'Your application is in motion.',
                under_review: 'Your application is in motion.',
                needs_info: 'Your application needs a reply.',
                accepted: 'Welcome to Dream Media.',
                declined: 'Your application has been reviewed.',
                closed: 'Your application has been closed.',
            },
            copies: {
                submitted: 'Track progress and talk directly with the team without leaving your account.',
                under_review: 'Track progress and talk directly with the team without leaving your account.',
                needs_info: 'The team has a question for you before it can make a decision.',
                accepted: 'Manage license windows, content deliverables, follow-ups, and your ongoing relationship with the Dream team.',
                declined: 'Review the decision below. You can submit a stronger application whenever you are ready.',
                closed: 'Review the closure reason below. You can create a new application when intake is open.',
            },
            applicationNumber: 'Application #{id}',
            progress: 'Application progress',
            submitted: 'Submitted',
            review: 'Review',
            decision: 'Decision',
            partnership: 'Partnership',
            needsInfoTitle: 'The team needs more information',
            needsInfoCopy: 'Read the latest update below and reply in the conversation.',
            declinedTitle: 'Not accepted this time',
            declinedFallback: 'The team decided not to move forward with this application.',
            closedTitle: 'Application closed',
            closedFallback: 'The Dream team closed this application without marking it as declined.',
            reapply: 'Create a new application',
            activeRoleCopy: 'Your media role is active. Product-license access is provided for the content plan agreed with the Dream team.',
            starterAccessCopy: 'Your {product} starter license is active for the content plan agreed with the Dream team.',
            basicProduct: 'Dream Basic',
            advancedProduct: 'Dream Advanced',
            licenseExpires: 'License expires',
            lifetimeAccess: 'Lifetime access already active',
            lifetimeAccessCopy: 'Your existing lifetime license does not need extensions. You can still submit published content for review and program records.',
            licenseRenewalCopy: 'Submit a published Dream video for approval to earn the access extension for your tier.',
            nextFollowUp: 'Next follow-up',
            notScheduled: 'Not scheduled',
            followUpCopy: 'The team will post schedule changes in your timeline.',
            affiliateSystem: 'Affiliate payout system',
            creatorLink: 'Creator link',
            preparingCode: 'Preparing your code',
            affiliateCopy: 'Your tracked affiliate link and commission payout tools are available from Referrals.',
            referralCopy: 'Your referral workspace is available from the sidebar.',
            conversation: 'Application conversation',
            updateCount: '{count} updates',
            dreamTeam: 'Dream team',
            viewContent: 'View submitted content',
            contentPending: 'Pending review',
            contentApproved: 'Approved',
            extendedUntil: 'License extended until {date}',
            approvedNoExtension: 'Approved — no timed extension was required',
            messagePlaceholder: 'Write a message to the Dream media team…',
            sendMessage: 'Send message',
            submitContentTitle: 'Submit published content',
            submitContentCopy: 'Share each live video or post here so the team can review and follow up.',
            publishedUrl: 'Published URL',
            noteOptional: 'Note (optional)',
            notePlaceholder: 'Context, results, or anything the team should know.',
            submitContent: 'Submit content',
            channelSnapshot: 'Channel snapshot',
            platform: 'Platform',
            audience: 'Audience',
            typicalViews: 'Typical views',
            language: 'Language',
            categories: 'Categories',
            applied: 'Applied',
            legacyTitle: 'Your media access is active.',
            legacyCopy: 'Your account already has the Dream media role. You can use referrals, downloads, configs, and creator resources from the dashboard.',
            openReferrals: 'Open referrals',
        },
        status: {
            submitted: 'Submitted',
            under_review: 'Under review',
            needs_info: 'Reply needed',
            accepted: 'Accepted',
            declined: 'Declined',
            closed: 'Closed',
        },
        program: {
            onboarding: 'Onboarding',
            active: 'Active',
            paused: 'Paused',
            inactive: 'Inactive',
            invited: 'Invited',
        },
        messages: {
            loadError: 'Failed to load the Media Hub',
            applicationSubmitted: 'Your media application has been submitted',
            applicationError: 'Please check your answers and try again.',
            messageSent: 'Message sent',
            messageError: 'Failed to send message',
            contentSubmitted: 'Content submitted for review',
            contentError: 'Failed to submit content',
        },
    },    footer: {
        product: 'Product',
        account: 'Account',
        community: 'Community',
        terms: 'Terms of Service',
        rights: 'All rights reserved.',
        disclaimer: 'Dream is not affiliated with Mojang AB or Microsoft.',
    },
};
